import React, { useMemo } from "react";
import LgvSelectField from "./LgvSelectField";
import {
  COUNTRY_OPTIONS,
  getCountryByCode,
  normalizeCountryAnswer,
  type CountryAnswer,
} from "../utils/countries";

type Props = {
  id?: string;
  name?: string;
  value: unknown;
  onChange: (value: CountryAnswer | null) => void;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  className?: string;
};

const UNKNOWN_COUNTRY_VALUE = "__unknown_country__";

const LgvCountryField: React.FC<Props> = ({
  id,
  name,
  value,
  onChange,
  disabled = false,
  required = false,
  placeholder = "Select country...",
  className,
}) => {
  const normalized = normalizeCountryAnswer(value);
  const options = useMemo(() => {
    if (!normalized || normalized.code) return COUNTRY_OPTIONS;
    return [
      {
        code: UNKNOWN_COUNTRY_VALUE,
        name: normalized.name,
        value: UNKNOWN_COUNTRY_VALUE,
        label: normalized.name,
      },
      ...COUNTRY_OPTIONS,
    ];
  }, [normalized]);

  const selectValue =
    normalized?.code || (normalized ? UNKNOWN_COUNTRY_VALUE : "");

  return (
    <LgvSelectField
      id={id}
      name={name}
      value={selectValue}
      options={options}
      disabled={disabled}
      required={required}
      placeholder={placeholder}
      searchable
      searchPlaceholder="Search country..."
      noOptionsMessage="No countries found"
      className={className}
      onChange={(nextValue) => {
        if (!nextValue) {
          onChange(null);
          return;
        }
        if (nextValue === UNKNOWN_COUNTRY_VALUE) {
          onChange(normalized);
          return;
        }
        onChange(getCountryByCode(nextValue));
      }}
    />
  );
};

export default LgvCountryField;
